import React, { useState, useEffect } from 'react';
import { ICourse } from '@cap/share/src/types/course';
import { logger, loginNewWrapper, lx } from '@cap/rzmt-core';
import { navigatePage } from '@cap/share/src/utils/navigation';
import { UserInfo } from '@cap/account';
import { getUserProfile, learningDuration, studyingRecently, registerCourses } from '@cap/share/src/apis/home';
import { getGrayTest } from '@cap/share/src/apis/course';
import { ENU_COURSE_TYPE, ENU_COURSE_TYPE_NAME } from '@/utils/course';
import { LearningTime, learningTimeManagement, nameLength } from '@/utils/func';
import SwitchTab from '@/components/SwitchTab';
// import { MyContext } from '@/App';
import './index.less';

interface LearningHistoryIProps {
  mockData: ICourse[];
  show: boolean;
}

// 动态加载图片
const getImagePath = (imageName: string) => {
  try {
    // eslint-disable-next-line import/no-dynamic-require
    return require(`../../../../assets/icons/${imageName}.png`);
  } catch (e) {
    console.error('Image loading failed:', e);
    return ''; // 返回一个默认图片路径
  }
};

const EmptyBox: React.FC<{ show: boolean }> = ({ show }) => {
  const type = !show ? '学习' : '报名';
  const login = () => {
    lx.moduleClick({
      bid: 'b_donation_s2xq5uqj_mc',
    });
    loginNewWrapper.goLogin();
  };

  return (
    <div className="empty-box">
      <img src={getImagePath('emptybox')} alt="" />
      <p>未获取到你的{type}数据</p>
      <span>立即登录查看吧～</span>
      <div className="button" onClick={() => login()}>
        立即登录
      </div>
    </div>
  );
};

const LoginEmptyBox: React.FC<{ show: boolean }> = ({ show }) => {
  const type = !show ? '学习' : '报名';
  return (
    <div className="empty-box">
      <img src={getImagePath('emptybox')} alt="" />
      <p>你还未{type}任何课程</p>
    </div>
  );
};

const LearningHistory: React.FC<LearningHistoryIProps> = ({ mockData, show }) => {
  const viewAll = () => {
    if (!show) {
      lx.moduleClick({
        bid: 'b_donation_p8kayaja_mc',
      });
    } else {
      lx.moduleClick({
        bid: 'b_donation_bmif8ytw_mc',
      });
    }
    navigatePage('/web/learning-history', { query: { type: show ? 'reservation' : 'study' }, windowOpen: true });
  };

  const onClickRemind = async (item) => {
    const { id, type, shortUrl, tenantId } = item;
    let urlPrefix = '/i/college';

    if ([ENU_COURSE_TYPE.VIDEO, ENU_COURSE_TYPE.ARTICLE].includes(type)) {
      try {
        const res = await getGrayTest({ tenant: shortUrl, tenantId });
        const { gray } = res.data || { gray: false };
        if (gray) {
          urlPrefix = '/web';
        }
      } catch (err) {
        logger.error(`灰度接口报错 ${err}`);
      }
    }
    const url = `${urlPrefix}/${shortUrl}/${ENU_COURSE_TYPE[type]}/${id}`;
    navigatePage(url, {
      windowOpen: true,
    });
  };
  return (
    <div className="learning-history">
      <div className={mockData.length > 0 ? 'h161' : ''}>
        {mockData.map((c: any, index) => {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <div className="learning-history-item" key={index} onClick={() => onClickRemind(c)}>
              <img src={c.coverImageUrl} alt="" />
              <div className="history">
                <span className="course-title">{c.title}</span>
                <div>
                  <span className="course-type">{ENU_COURSE_TYPE_NAME[c.type]}</span>
                  <span className="course-progress">{Math.trunc(c.maxProgress / 100)}%</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {mockData.length > 0 ? (
        <div className="button" onClick={() => viewAll()}>
          <span>查看全部</span>
          <img
            className="dimension-right-icon"
            src="//img.meituan.net/mtdxweb/846f5a046757b60fe85e2d2d8af434a7426.png"
            alt=""
          />
        </div>
      ) : (
        <LoginEmptyBox show={show} />
      )}
    </div>
  );
};

const UserCard: React.FC = () => {
  const defaultAvatar = 'https://p0.meituan.net/mtdxweb/mtdx_default_avatar_v2.png';
  const [userInfo, setUserInfo] = useState<UserInfo | null>();
  const [avatarUrl, setAvatarUrl] = useState<string>(defaultAvatar);
  const [learningTime, setLearningTime] = useState<LearningTime>({
    today: 0,
    cumulative: 0,
  });
  const [registerList, setRegisterList] = useState<ICourse[]>([]);
  const [studyingList, setStudyingList] = useState<ICourse[]>([]);
  const [dataList, setDataList] = useState<ICourse[]>([]);
  const [loginSuccess, setLoginSuccess] = useState<boolean>(false);

  const getUserInfo = async () => {
    const user = await loginNewWrapper.getUserInfo();
    if (user) {
      setUserInfo(user);
      const { data: studyingData } = await studyingRecently();
      setDataList(studyingData);
      setStudyingList(studyingData);
      setLoginSuccess(true);
      const params = {
        userId: user.userId,
      };
      const { data: userData } = await getUserProfile(params);
      setAvatarUrl(userData.avatarUrl || defaultAvatar);
      const { data: registerData } = await registerCourses();
      setRegisterList(registerData);
      const { data } = await learningDuration();
      setLearningTime(learningTimeManagement(data));
    } else {
      setLoginSuccess(true);
    }
  };

  useEffect(() => {
    getUserInfo();
  }, []);

  const [show, setShow] = useState<boolean>(false);

  const switchTabChange = () => {
    setShow((prevShow) => {
      if (prevShow) {
        lx.moduleClick({
          bid: 'b_donation_p8kayaja_mc',
        });
      } else {
        lx.moduleClick({
          bid: 'b_donation_bmif8ytw_mc',
        });
      }
      const newShow = !prevShow;

      setDataList(() => {
        return newShow ? registerList : studyingList;
      });
      return newShow;
    });
  };

  const tabs = [
    {
      label: '正在学习',
      value: 1,
    },
    {
      label: '报名课程',
      value: 2,
    },
  ];

  return (
    <div className="user-card">
      {!userInfo ? (
        <div className="use-name">
          <img src={avatarUrl} alt="" />
          <span>Hi～ 你好</span>
        </div>
      ) : (
        <div className="login-name">
          <img src={avatarUrl} alt="" />
          <div className="learning-information">
            <span className="name">{nameLength(userInfo?.userName)}</span>
            <div>
              <span className="tab">已学</span>
              <span className="value">{learningTime.cumulative}</span>
              <span className="unit segmentation">小时</span>

              <span className="tab">今天</span>
              <span className="value">{learningTime.today}</span>
              <span className="unit">分钟</span>
            </div>
          </div>
        </div>
      )}

      <SwitchTab onChange={() => switchTabChange()} tabs={tabs} tabItemWidth="115px" />
      {loginSuccess &&
        (userInfo ? (
          <div>
            <LearningHistory mockData={dataList} show={show} />
          </div>
        ) : (
          <div>
            <EmptyBox show={show} />
          </div>
        ))}
    </div>
  );
};

export default UserCard;
